import React, { useState } from 'react';
import { Grid, TextField, Button, Box, Alert } from '@mui/material';
import '../styles/QueryForm.css';

const QueryForm = ({ onFetchDetails, isLoading }) => {
  const [tokenId, setTokenId] = useState('');
  const [error, setError] = useState('');

  const handleTokenIdChange = (e) => {
    setTokenId(e.target.value);
    setError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!tokenId.trim()) {
      setError('Please enter a valid Evidencer record number');
      return;
    }
    
    // Check if the input is a valid number
    if (isNaN(tokenId) || parseInt(tokenId) <= 0) {
      setError('Record number must be a positive integer');
      return;
    }
    
    // Call the fetch function from the parent component
    onFetchDetails(tokenId);
  };

  return (
    <Box className="query-form">
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={8}>
            <TextField
              id="tokenId"
              label="Enter the Evidencer record number here"
              variant="outlined"
              value={tokenId}
              onChange={handleTokenIdChange}
              fullWidth
              className="query-input"
              error={!!error}
              helperText={error}
              disabled={isLoading}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button 
              variant="contained" 
              color="primary"
              type="submit"
              className="query-button"
              fullWidth
              disabled={isLoading}
            >
              {isLoading ? 'Fetching...' : 'Fetch Record Details'}
            </Button>
          </Grid>
        </Grid>
        
        {error && (
          <Box mt={2}>
            <Alert severity="error">{error}</Alert>
          </Box>
        )}
      </form>
    </Box>
  );
};

export default QueryForm;